import React, { useState, useEffect, useRef } from 'react';
import { Input } from 'antd';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import debounce from 'lodash/debounce';
// components
import InputField from '../../../molecules/inputField';
// actions
import groupsAction from '../../../../redux/actions/groups';
// types
import { stateType } from '../../../../types/types';
// icons
import { ReactComponent as SearchIcon } from '../../../../assets/image/inputs/search.svg';
import Icon from '@ant-design/icons';
// styles
import '../style.scss';

const SearchGroups: React.FC = () => {
  const [focus, setState] = useState(false);
  const dispatch = useDispatch();
  const inputField: any = useRef(null);
  const params: any = useSelector((state: stateType) => state.groups.params, shallowEqual);
  const loader = useSelector((state: stateType) => state.groups.loader, shallowEqual);

  useEffect(() => {
    if (focus) {
      !loader && inputField.current.focus();
    }
  }, [loader]);

  const onChange = async (e: any) => {
    const value = e.target.value.trim().replace(/\sgroup|\sgrou|\sgro|\sgr|\sg/gi, '');
    try {
      await groupsAction.params({ ...params, name: value.trim(), page: 1 });
      dispatch(groupsAction.get());
    } catch (e) {
      console.log(e);
    }
  };

  const onFocus = () => {
    setState(true);
  };
  return (
    <div className="search-clients-field">
      <InputField>
        <Input
          prefix={<Icon component={SearchIcon} style={{ fontSize: 24, color: '#92929D' }} />}
          defaultValue={params.name ? params.name : ''}
          onFocus={onFocus}
          ref={inputField}
          disabled={loader}
          placeholder="Search groups here..."
          className="search-clients-field__input"
          onChange={debounce(onChange, 600)}
        />
      </InputField>
    </div>
  );
};

export default SearchGroups;
